export {
    ALZ_ACTION_SERVICE_NAME,
    ALZ_ACTION_SERVICE_PROVIDER_NAME
} from './alz-action.service'